<template>
    <div>
        <dl>
            <dt v-b-toggle="'collapse-' + index" @click="registerStatistics()"><span>Q</span>{{ this.question }}</dt>
            <b-collapse :id="'collapse-' + index">
                <dd v-html="this.answer"></dd>
                <dd class="LeadText" v-if="this.text">＜{{ this.text }}＞</dd>
                <dd class="LinkURL" v-if="this.url"><a v-bind:href="this.url" target="_blank">{{ this.url }}</a></dd>
            </b-collapse>
        </dl>
    </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    props: ["index", "question", "answer", "text", "url"],
    data() {
        return {
            isOpen: false,
        }
    },
    name: "QaBox",
    methods: {
        ...mapActions(['statistics']),
        registerStatistics() {
            if (!this.isOpen) {
                this.statistics({type: 3, value: this.question});
                this.isOpen = true;
            } else {
                this.isOpen = false;
            }
        }
    },
};
</script>
<style scoped>
@media screen and (max-width: 510px) {
    dd >>> img {
        width: 100%;
    }
}
dd {
    white-space: pre-wrap
}

.qa_box dl {
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    margin-bottom: 20px;
}

.qa_box dl dt {
    font-size: 14px;
    font-weight: bold;
    background: #fafdff;
    padding: 20px;
    border-radius: 10px;
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
}

.qa_box dl dt span {
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    width: 26px;
    line-height: 26px;
    background: #076cb9;
    margin-right: 10px;
}

.qa_box dl dd {
    font-size: 14px;
    padding: 20px;
}

.qa_box dl dd.LeadText {
    padding-bottom: 0px;
}

.qa_box dl dd.LinkURL {
    padding-top: 0px;
    word-break: break-all;
}
</style>
